import { LayoutsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { TCall } from 'app/queries/types/TCall';
import type { layoutsKeys } from './layoutsKeys';

type TParams = QueryFunctionContext<ReturnType<typeof layoutsKeys.availableByOrganization>>;

export const createFetchAvailableLayoutsQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ organizationId }], signal }: TParams) =>
    call(() => cancelOnSignal(LayoutsService.getOrganizationLayouts({ oid: organizationId }), signal));
